/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderComponentHealthElements } from './providerComponentHealthElements';


export interface ProviderComponentHealth { 
    /**
     * Reporting agent identifier
     */
    agent_id?: string;
    components?: Array<ProviderComponentHealthElements>;
    /**
     * Job identifier. This will contains the job id when payload is requested from provider.
     */
    job_id?: string;
    peer_components?: Array<ProviderComponentHealthElements>;
    /**
     * Report time for inventory health information
     */
    report_time?: Date;
}

